export const API_SUCCESS_CODE_MOCK = 200;
export const API_SUCCESS_STATUS_TEXT_MOCK = 'Success';
export const API_ERROR_CODE_MOCK = 400;
export const API_ERROR_STATUS_TEXT_MOCK = 'Error';
